import { getCachedUserProducts } from '@/utils/common';

export function requestNotificationPermission() {
  if (!('Notification' in window)) {
    console.log('🔔 当前浏览器不支持系统通知');
    return Promise.resolve('unsupported');
  }
  if (Notification.permission === 'granted') {
    console.log('🔔 系统通知已授权（后台新单可响铃）');
    return Promise.resolve('granted');
  }
  if (Notification.permission === 'denied') {
    console.log('🔕 系统通知已被拒绝，切到其他页面时可能无法响铃');
    return Promise.resolve('denied');
  }
  return Notification.requestPermission().then((perm) => {
    console.log(
      perm === 'granted'
        ? '🔔 系统通知已授权（后台新单可响铃）'
        : '🔕 系统通知未授权，切到其他页面时可能无法响铃'
    );
    return perm;
  });
}

export function showNewOrderNotification(type, count = 1) {
  if (!('Notification' in window) || Notification.permission !== 'granted') {
    return false;
  }

  const productType = String(type)
  const product = getCachedUserProducts().find(item => item.type === productType)
  const label = product?.name || `Product ${productType}`
  const body = count > 1
    ? `${count} new orders on ${label}`
    : `New order on ${label}`;

  try {
    const notification = new Notification('New Order', {
      body,
      tag: `new-order-${type}`,
      renotify: true,
      silent: false,
    });
    notification.onclick = () => {
      window.focus();
      notification.close();
    };
    console.log('🔔 已发送系统通知（后台响铃）');
    return true;
  } catch (err) {
    console.warn('系统通知失败:', err);
    return false;
  }
}
